import React, { useCallback, useEffect, FC } from 'react';

import { FactorinCheckClass, Checkbox as DefaultCheckbox, useMemoDeps } from 'Modules/ui';
import { useTranslation } from 'Modules/core/i18n';
import { usePagination } from 'Modules/business/data';


const FactorinCheck = new FactorinCheckClass();

type CheckedRowsType = typeof FactorinCheck.defaultModel;
type CheckboxProps = {
    paginationPath: string;
    checkedRows: CheckedRowsType;
    onChange: (model: CheckedRowsType) => void;
    className?: string;
}

export const Checkbox: FC<CheckboxProps> = React.memo(({
    paginationPath,
    checkedRows,
    onChange,
    className,
}) => {
    const itemsCount = usePagination(paginationPath, 'total') || 0;

    useEffect(
        () => onChange(FactorinCheck.defaultModel),
        [onChange],
    );
    const checked = useMemoDeps(FactorinCheck.getAll, [itemsCount, checkedRows]);
    const onCheck = useCallback(
        () => onChange(FactorinCheck.updateAll(itemsCount, checkedRows)),
        [checkedRows, itemsCount, onChange],
    );

    const { t } = useTranslation('entitysList');
    return (
        <DefaultCheckbox
            checked={checked}
            onChange={onCheck}
            className={className}
        >
            {t('checkbox')}
        </DefaultCheckbox>
    );
});
